/** @jsxImportSource @emotion/react */
import { useTheme } from '@emotion/react';
import { useContext } from 'react';

import { makeUrlAbsolute } from '@common/utlis';
import { PageContext } from '@stories/templates/Context/pageContext';

type HeadlineProps = {
  brand?: string | null;
  id: number;
  name: string;
  price: string;
  url: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

const Headline: React.FC<HeadlineProps> = ({ brand, id, name, price, url, onClick }) => {
  const theme = useTheme();
  const { storeCode } = useContext(PageContext);

  const headlineClass = {
    color: theme.color.copy,
    display: 'block',
    fontSize: theme.font.size.large,
    fontWeight: 'bold',
    letterSpacing: '-0.02em',
    lineHeight: '110%',

    '::after': {
      bottom: 0,
      content: "''",
      cursor: 'pointer',
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 1
    }
  } as const;

  return (
    <h3>
      <a
        css={headlineClass}
        href={makeUrlAbsolute(url)}
        data-list-name={name}
        data-list-productid={id}
        data-list-price={price}
        data-list-brand={brand}
        dangerouslySetInnerHTML={{ __html: name }}
        onClick={onClick}
      />
      {storeCode === 'bodylab' && brand && (
        <span css={{ color: theme.color.grey.g40, lineHeight: '100%' }}>{brand}</span>
      )}
    </h3>
  );
};
export default Headline;
export type { HeadlineProps };
